'use strict';

/**
 * Переключение табов в футере
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-footerTab"]- поиск элементов по селектору
 * @sourceCode
 */
(function ($) {
    let tab = $('.footer-tab__link');

    tab.on('click', function() {
        $(this)
            .addClass('is-active').siblings().removeClass('is-active')
            .closest('.js-footerTab').find('.footer-tab__block').addClass('_hide').eq($(this).index()).removeClass('_hide');
    });

})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/footer-tab.js